import { DateTime } from 'luxon';

// 날짜 ISO 문자열 → KST 시간 문자열로 변환
export function toKST(dateString, format = 'yyyy-MM-dd HH:mm') {
    if (!dateString) return '';
    try {
        return DateTime.fromISO(dateString, { zone: 'utc' }).setZone('Asia/Seoul').toFormat(format);
    } catch (e) {
        console.warn('날짜 변환 오류:', dateString);
        return dateString;
    }
}
